import type { AllowlistFiltersInput } from '@travel-planner/shared/schemas';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

export const useListAllowlist = (input: AllowlistFiltersInput) =>
  trpc.accounts.listAllowlist.useQuery(input, {
    placeholderData: keepPreviousData,
  });
